var _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgLogoutIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 24,
    height: 20,
    fill: "none",
    viewBox: "0 0 24 20",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "#000",
    d: "M14.372 0C11.198.002 8.231 1.63 6.437 4.35c-.225.35-.137.824.197 1.062.335.238.792.151 1.025-.194 1.318-2 3.4-3.317 5.717-3.616 2.316-.298 4.644.45 6.393 2.057 1.749 1.607 2.75 3.915 2.75 6.34 0 2.426-1.001 4.734-2.75 6.341-1.75 1.607-4.077 2.355-6.393 2.057-2.317-.299-4.399-1.615-5.717-3.616-.233-.345-.69-.431-1.025-.193-.334.238-.422.71-.197 1.061 1.906 2.892 5.129 4.536 8.495 4.334 3.367-.202 6.387-2.22 7.958-5.322 1.573-3.1 1.468-6.83-.275-9.83-1.743-3-4.87-4.832-8.243-4.831z"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fill: "#FF5417",
    d: "M4.9 12.919l-2.065-2.15h13.018V9.23H2.835l2.066-2.15-1.044-1.085L0 9.999l3.857 4.005 1.044-1.085z"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLogoutIcon);
export default __webpack_public_path__ + "static/media/logout-icon.ec3d5491fb283da02979b8531b001488.svg";
export { ForwardRef as ReactComponent };